var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getSessionShop, getViewerIdAndKind, isBarberSessionView, isShopSessionView, useSession, } from '../../../infra/session';
import { useApiQuery } from '../../../infra/api';
import { endpoints as shopReportEndpoints } from '../../../shop/reports/network';
import { endpoints as barberReportEndpoints } from '../../../barber/network';
import { getStatisticsReportDates } from './utils';
var useShopProductivity = function (canSeeEngage) {
    var session = useSession().data;
    var shop = getSessionShop(session);
    var shopStatistics = useApiQuery({
        endpoint: shopReportEndpoints.shopStatisticsQuery,
        payload: __assign({ shopId: shop === null || shop === void 0 ? void 0 : shop.id }, getStatisticsReportDates(shop === null || shop === void 0 ? void 0 : shop.timezone)),
        options: {
            enabled: !!shop && isShopSessionView(session.view) && canSeeEngage,
        },
    }).data;
    if (shopStatistics) {
        return shopStatistics.shop.productivity;
    }
    return null;
};
var useBarberProductivity = function (canSeeEngage) {
    var session = useSession().data;
    var shop = getSessionShop(session);
    var viewerIdAndKind = getViewerIdAndKind(session);
    var barberStatistics = useApiQuery({
        endpoint: barberReportEndpoints.barberProfileStatisticsQuery,
        payload: __assign({ shopId: shop === null || shop === void 0 ? void 0 : shop.id, barberId: viewerIdAndKind.id }, getStatisticsReportDates(shop === null || shop === void 0 ? void 0 : shop.timezone)),
        options: {
            enabled: !!shop && isBarberSessionView(session.view) && canSeeEngage,
        },
    }).data;
    if (barberStatistics) {
        return barberStatistics.productivity;
    }
    return null;
};
export var useProductivity = function (canSeeEngage) {
    var session = useSession().data;
    var shopProductivity = useShopProductivity(canSeeEngage);
    var barberProductivity = useBarberProductivity(canSeeEngage);
    if (session) {
        return isShopSessionView(session.view) ? shopProductivity : barberProductivity;
    }
    return null;
};
